const INITIAL_STATE = {
	data: {},
	errors: {}
  }
		  
  const getChannelsCatalog = (state = INITIAL_STATE, action) => {
	switch (action.type) {
	case 'GET_CHANNELS_SUCCESSFULLY':
		return { ...state, ...INITIAL_STATE, data: action.data }
	case 'GET_CHANNELS_FAILED':
		return { ...state, ...INITIAL_STATE, errors: action.data }
	default:
		return { ...state }
	}
  };
		  
  export default getChannelsCatalog;